import type { TreatmentOverview } from "../hooks/useTreatmentOverviews";

import { DetailShell } from "./DetailShell";
import { TreatmentDetailDeeplinkLoader } from "./TreatmentDetailDeeplinkLoader";
import { TreatmentDetailReadyContent } from "./TreatmentDetailReadyContent";
import { TreatmentDetailSkeleton } from "./TreatmentDetailSkeleton";

export type TreatmentDetailPageViewProps = {
  treatment?: TreatmentOverview;
  treatmentCode?: string;
  translationsReady?: boolean;
  loading?: boolean;
  error?: Error;
  onRetry?: () => void;
};

export const TreatmentDetailPageView = ({
  treatment,
  treatmentCode,
  translationsReady = true,
  loading = false,
  error,
  onRetry = () => undefined,
}: TreatmentDetailPageViewProps) => {
  if (treatment) {
    if (!translationsReady) {
      return (
        <DetailShell>
          <TreatmentDetailSkeleton />
        </DetailShell>
      );
    }

    return <TreatmentDetailReadyContent treatment={treatment} />;
  }

  return (
    <TreatmentDetailDeeplinkLoader
      treatmentCode={treatmentCode}
      query={{
        treatment: undefined,
        hasData: !loading && !error,
        loading,
        error,
        refetch: onRetry,
      }}
    />
  );
};
